package com.shadowings.gero.data.lessons.chapter15

import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.chapter14.getIlSegretoDellaPiramideQuizContent
import com.shadowings.gero.data.lessons.toHieroExplanation
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_significato_dei_nomi_1
import gero.composeapp.generated.resources.exp_content_significato_dei_nomi_2
import gero.composeapp.generated.resources.exp_content_significato_dei_nomi_3
import gero.composeapp.generated.resources.exp_content_significato_dei_nomi_4
import gero.composeapp.generated.resources.exp_content_significato_dei_nomi_5
import gero.composeapp.generated.resources.exp_content_significato_dei_nomi_6
import gero.composeapp.generated.resources.exp_content_significato_dei_nomi_7
import gero.composeapp.generated.resources.exp_title_significato_dei_nomi
import kotlin.random.Random

// New signs needed to read the throne names of the next lesson (Djedefre, Khafre, Sahure).
val significatoDeiNomiHieroCodes = listOf("R11", "N28", "D61")

// Already-taught signs, used only as extra pronunciation distractors.
private val significatoDeiNomiReviewHieroCodes = listOf("U28", "U33", "N24", "N5", "D36", "I9", "Y5", "F35", "G43", "D28")

fun getSignificatoDeiNomiContent(
    hiero: List<Hiero>,
    languageCode: String
): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_significato_dei_nomi,
            content = Res.string.exp_content_significato_dei_nomi_1,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_significato_dei_nomi,
            content = Res.string.exp_content_significato_dei_nomi_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_significato_dei_nomi,
            content = Res.string.exp_content_significato_dei_nomi_3,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_significato_dei_nomi,
            content = Res.string.exp_content_significato_dei_nomi_4,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_significato_dei_nomi,
            content = Res.string.exp_content_significato_dei_nomi_5,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_significato_dei_nomi,
            content = Res.string.exp_content_significato_dei_nomi_6,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_significato_dei_nomi,
            content = Res.string.exp_content_significato_dei_nomi_7,
            face = Faces.Perfect,
            character = Characters.Alyn,
        )
    )

    return intro + significatoDeiNomiHieroCodes.toHieroExplanation(hiero, languageCode)
}

// 3 questions on the new signs + 5 Abydos names from NOMI_IMPORTANTI + 2 from the chapter 14 review.
fun getSignificatoDeiNomiQuizContent(
    hiero: List<Hiero>,
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String,
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> {
    val newSignQuestions = buildHieroQuizContent(
        hiero = hiero,
        hieroContent = significatoDeiNomiHieroCodes.toHieroExplanation(hiero, languageCode),
        languageCode = languageCode,
        previousHieroContent = significatoDeiNomiReviewHieroCodes.toHieroExplanation(hiero, languageCode)
    ).take(significatoDeiNomiHieroCodes.size)

    val chapter14Review = getIlSegretoDellaPiramideQuizContent(
        hiero = hiero,
        words = words,
        verbs = verbs,
        languageCode = languageCode,
        verbSentences = verbSentences,
        random = random
    ).shuffled(random).take(2)

    return newSignQuestions + getNomiImportantiQuizContent(words).take(5) + chapter14Review
}
